// export const root = 'http://localhost:4000';
// export const root = 'https://5fm19.sse.codesandbox.io/';
export const root =
  'https://artem-pizza--server.herokuapp.com/';

export const serverImgs = `${root}`;
